module.exports = __webpack_public_path__ + "img/panch_cuento_7.633bb94c.png";